import { esES } from "@mui/material/locale";
import saMessages from "../locales/es_ES.json";

const saLang = {
  messages: {
    ...saMessages,
  },
  muiLocale: esES,
  locale: "es",
};
export default saLang;
